import { el, fragment } from '../dom.js';
import { t } from '../i18n.js';
import { overviewPanel } from './crawl-overview.js';
import { sourcesPanel } from './crawl-sources.js';
import { queuePanel } from './crawl-queue.js';

// Three views of one pipeline, which is why they are tabs and not three pages:
// the number on the overview is only worth showing if the queue it points at is
// one click away. The roadmap held these apart as three separate entries for
// months and each stayed unbuilt while the other two justified it.
const TABS = [
  { id: 'overview', label: () => t.crawlTabOverview, render: overviewPanel },
  { id: 'sources', label: () => t.crawlTabSources, render: sourcesPanel },
  { id: 'queue', label: () => t.crawlTabQueue, render: queuePanel },
];

export async function renderCrawl() {
  const outlet = el('div', {});
  let current = 'overview';

  const show = async (id) => {
    current = id;
    for (const button of buttons) {
      const selected = button.dataset.tab === id;
      button.setAttribute('aria-selected', String(selected));
      // aria-selected alone is a state only a screen reader can see. The
      // primary style is what the eye reads, and the tokens already define it.
      button.className = selected ? 'btn btn-primary' : 'btn';
    }
    const tab = TABS.find((entry) => entry.id === id) ?? TABS[0];
    // `reload` re-renders the panel that called it rather than the page: after
    // approving a batch the queue has to change, and nothing else has.
    outlet.replaceChildren(await tab.render({ reload: () => show(current) }));
  };

  const buttons = TABS.map((tab) => {
    const button = el('button', {
      type: 'button', class: 'btn', role: 'tab', 'aria-selected': 'false',
    }, tab.label());
    button.dataset.tab = tab.id;
    button.addEventListener('click', () => show(tab.id));
    return button;
  });

  await show('overview');

  return fragment([
    el('h1', { class: 'pub-title' }, t.crawlTitle),
    el('p', { class: 'pub-lede' }, t.crawlLede),
    el('div', { class: 'row', role: 'tablist' }, buttons),
    outlet,
  ]);
}
